import { createSelector } from '@ngrx/store'
import { AppState } from '../app.state'
import { FeatureMYPState } from './feature-myp.state'

export const getFeatureMYP = (state: AppState) => state.featureManageYourProjects

export const selectMYPSearchDone = createSelector(getFeatureMYP, (state: FeatureMYPState) => state.isSearchDone)

export const selectMYPIsLoadingSearch = createSelector(getFeatureMYP, (state: FeatureMYPState) => state.isLoading)

export const selectMYPSearchResult = createSelector(getFeatureMYP, (state: FeatureMYPState) => state.searchResult)

export const selectMYPSearchRequest = createSelector(getFeatureMYP, (state: FeatureMYPState) => state.searchRequest)

export const selectMYPisDownloadLoading = createSelector(getFeatureMYP, (state: FeatureMYPState) => state.isDownloadLoading)
